import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { NotifierService } from '../services/notifier.service';
import { defaultErrorMessage, errorMessages } from '../utils/error-message';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly notifier = inject(NotifierService);

  intercept(
    request: HttpRequest<unknown>,
    handler: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return handler.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error) {
          switch (error.status) {
            case 406:
            case 404:
              if (error.error instanceof Blob) {
                this.getBlobError(error.error);
              } else {
                const errorType =
                  error.error?.message ?? error.error?.customMessage;
                this.getMessageError(errorType);
              }
              break;
            case 403:
              if (error.error.customMessage !== 'INVALID_TOKEN') {
                this.onErrorMessage(
                  'Sessão expirada!',
                  'Sua sessão expirou. Faça login novamente para continuar.'
                );
              }
              break;
            case 401:
              this.onErrorMessage(
                'Sessão expirada!',
                'Sua sessão expirou. Faça login novamente para continuar.'
              );
              break;
            default:
              this.onErrorMessage(
                'Erro inesperado!',
                'Tente novamente mais tarde.'
              );
              break;
          }
        }
        return throwError(() => error);
      })
    );
  }

  private onErrorMessage(message: string, alternative: string) {
    this.notifier.showNotification({
      messageType: 'errorNotifier',
      horizontalPosition: 'left',
      dismissMessage: 'OK',
      alternative,
      message,
    });
  }

  private getMessageError(errorType: string) {
    const error = errorMessages[errorType];
    if (error) {
      this.onErrorMessage(error.message, error.alternative);
    } else {
      this.onErrorMessage(
        defaultErrorMessage.message,
        defaultErrorMessage.alternative
      );
    }
  }

  private getBlobError(blobError: Blob) {
    blobError.text().then((text: string) => {
      try {
        const jsonError = JSON.parse(text);
        const errorType = jsonError.message ?? jsonError.customMessage;
        this.getMessageError(errorType);
      } catch {
        this.onErrorMessage(
          defaultErrorMessage.message,
          defaultErrorMessage.alternative
        );
      }
    });
  }
}
